import { Menu, Tab } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import { useEffect, useState } from 'react';
import Digital from './Digital';
import ClonedItemsModal from '../../../features/MediaAssets/Details/ClonedItemsModal';
import MapComponent from './MapComponent';
import SectionsMain from '../../../features/MediaAssets/Sections/SectionsMain';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import OrderInfomation from '../../../features/MediaAssets/Sections/OrderInfomation';
import LoadingComponent from '../../layout/LoadingComponent';

export default observer(function MyFolderFileList() {
  const {
    TemplateStore,
    commonStore,
    userStore,
    userStore: { user },
  } = useStore();

  const { assetTypeRegistry, loadAssetTypes } = TemplateStore;

  const [panes, setPanes] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [feID, setFeID] = useState<string[]>([]);

  useEffect(() => {
    if (assetTypeRegistry.size <= 1) loadAssetTypes();
  }, [assetTypeRegistry.size, loadAssetTypes]);

  useEffect(() => {
    setLoading(true);
    const digitalComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVT01')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPageAssetsSegment
                ?.AVILVPASTP01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ), //"Digital"
      render: () => <Digital />,
    };
    const mapComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVT02')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPageAssetsSegment
                ?.AVILVPASTP02 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ), //"GPS"
      render: () => <MapComponent />,
    };
    const clonedComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVT03')}>
          {
            (
              userLanguage[0].AssetsViewItemLevelViewPageAssetsSegment
                ?.AVILVPASTP03 as any
            )?.[`${commonStore.language.key}`]
          }
        </Menu.Item>
      ), //'Cloned Items',
      render: () => <ClonedItemsModal />,
    };
    const sectionsComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVT04')}>
          {userStore.user?.customerName === 'Restoration'
            ? (
                userLanguage[0].AssetsViewItemLevelViewPageAssetsSegment
                  ?.AVILVPASTP05 as any
              )?.[`${commonStore.language.key}`]
            : (
                userLanguage[0].AssetsViewItemLevelViewPageAssetsSegment
                  ?.AVILVPASTP04 as any
              )?.[`${commonStore.language.key}`]}
        </Menu.Item>
      ), //"Physical"
      render: () => <SectionsMain />,
    };
    const ordersComponent = {
      menuItem: (
        <Menu.Item disabled={commonStore.filterModeZero?.includes('AVLAVT05')}>
          {user?.customerName === 'RAI' ? 'Workflow Process' : (
                userLanguage[0].AssetsViewItemLevelViewPageAssetsSegment
                  ?.AVILVPASTP06 as any
              )?.[`${commonStore.language.key}`]}
        </Menu.Item>
      ), //"Orders"
      render: () => <OrderInfomation />,
    };
    const tempPanes: any = [];
    const tempFeID: string[] = [];
    if (
      !commonStore.filterModeTwo?.includes('AVLAVT01') &&
      user?.customerName !== 'CG'
    ) {
      tempPanes.push(digitalComponent);
      tempFeID.push('AVLAVT01');
    }
    if (
      !commonStore.filterModeTwo?.includes('AVLAVT02') &&
      user?.customerName !== 'CG'
    ) {
      tempPanes.push(mapComponent);
      tempFeID.push('AVLAVT02');
    }
    if (
      !commonStore.filterModeTwo?.includes('AVLAVT03') &&
      user?.customerName !== 'CG'
    ) {
      tempPanes.push(clonedComponent);
      tempFeID.push('AVLAVT03');
    }
    if (!commonStore.filterModeTwo?.includes('AVLAVT04')) {
      tempPanes.push(sectionsComponent);
      tempFeID.push('AVLAVT04');
    }
    if (!commonStore.filterModeTwo?.includes('AVLAVT05')) {
      tempPanes.push(ordersComponent);
      tempFeID.push('AVLAVT05');
    }

    setPanes(tempPanes);
    setFeID(tempFeID);
    //eslint-disable-next-line
  }, [
    commonStore.filterModeTwo,
    commonStore.filterModeZero,
    userStore.user?.customerName,
  ]);

  useEffect(() => {
    if (commonStore.filterModeZero?.includes('AVLAVD03')) {
      setActiveIndex(0);
    } else {
      var index = 0;
      for (var id of feID) {
        if (commonStore.filterModeOne.includes(id)) {
          setActiveIndex(index);
          break;
        }
        index++;
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
    //eslint-disable-next-line
  }, [commonStore.filterModeZero, commonStore.filterModeOne, panes, feID]);

  return (
    <>
      {loading ? (
        <LoadingComponent />
      ) : (
        <Tab
          panes={panes}
          style={{ height: '100%' }}
          defaultActiveIndex={activeIndex}
        />
      )}
    </>
  );
});
